import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import Spinner from "./components/Spinner";
const AppRoot = lazy(() => import('base/AppRoot'));

// Render an empty div until the token check is done
// The createElement is for unit test

ReactDOM.render(<Suspense fallback={<div><Spinner large/></div>}>
  <AppRoot />
</Suspense>, document.getElementById("app-host") || document.createElement("div"));